/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {DrawerListExampleInteractive, DrawerListExampleOnlyToVisualize, DrawerListExampleDefault, DrawerListExampleSingleItem, DrawerListExampleMarkup} from 'Docs/uilib/components/fragments/drawer-list/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    p: "p",
    strong: "strong"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsx(_components.h3, {
      children: "Default DrawerList, triggered by a ToggleButton"
    }), "\n", _jsx(DrawerListExampleInteractive, {}), "\n", _jsx(_components.h3, {
      children: "DrawerList list - only to visualize"
    }), "\n", _jsx(DrawerListExampleOnlyToVisualize, {}), "\n", _jsx(_components.h3, {
      children: "Default DrawerList"
    }), "\n", _jsx(DrawerListExampleDefault, {}), "\n", _jsx(_components.h3, {
      children: "Custom event and link on single item"
    }), "\n", _jsx(DrawerListExampleSingleItem, {}), "\n", _jsx(_components.h3, {
      children: "Using List and Items markup"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "NB:"
      }), " By using this method you lose currently a lot of the core functionality like keyboard support and other accessibility features."]
    }), "\n", _jsx(DrawerListExampleMarkup, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
